<template>
    <div class="text-gray-200">
        <LoginOrSignup />
    </div>
</template>

<script>  
import LoginOrSignup from './LoginOrSignup.vue'

export default {
    name: "LoginPage",
    components: {
        LoginOrSignup
    }
}
 </script>